import { useQueryClient } from '@tanstack/react-query';
import useApiMutation from '_api/mutations/useApiMutation';
import { GET_ALL_ADMIN_THERAPIST_KEY } from '_api/queries/therapist';
import { Admin, AdminPayload } from '_api/types';

export const CREATE_HOSPITAL_ADMIN_KEY = 'create-hospital-admin';

export const useCreateHospitalAdmin = () => {
  const queryClient = useQueryClient();
  return useApiMutation<Admin, AdminPayload>(
    () => '/user/create-hospital-admin',
    'post',
    {},
    {
      mutationKey: [CREATE_HOSPITAL_ADMIN_KEY],
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [GET_ALL_ADMIN_THERAPIST_KEY] });
      },
    },
    (body: AdminPayload) => JSON.stringify(body),
  );
};
